import { FormMode } from '../form-mode'
import { FormModel } from '../form-model'

export enum FormHeaderBehaviour {
  Readonly,
  Edit,
  Both,
}

export const shouldBeShownCustomUIHeader = (mode: FormMode, formModel: FormModel): boolean => {
  if (!formModel.header?.customUI) return false

  if (formModel.header?.behaviour === FormHeaderBehaviour.Edit && mode !== 'Edit') return false
  if (formModel.header?.behaviour === FormHeaderBehaviour.Readonly && mode !== 'Readonly') return false

  return true
}
